// Card definitions for Feast of Gods
// Each card represents a mythological character with special powers

const cards = [
  {
    id: 'fenrir',
    name: 'Fenrir',
    team: 'werewolf',
    description: 'Hiçbir özel gücü yoktur, sadece bir kurttur.',
    actionDescription: 'Hiçbir aksiyonun yok. Diğer kurtlarla birlikte çalış.',
    turnOrder: 0,
    image: '/images/cards/fenrir.png',
    action: 'NONE',
    targets: ['none']
  },
  {
    id: 'hel',
    name: 'Hel',
    team: 'werewolf',
    description: 'Başka bir oyuncunun kartını görür.',
    actionDescription: 'Kartını görmek istediğin bir oyuncu seç.',
    turnOrder: 2,
    image: '/images/cards/hel.png',
    action: 'VIEW_PLAYER_CARD',
    targets: ['player']
  },
  {
    id: 'hades',
    name: 'Hades',
    team: 'werewolf',
    description: 'Ortadaki kartlardan birini görür.',
    actionDescription: 'Ortadaki kartlardan birini seç ve gör.',
    turnOrder: 3,
    image: '/images/cards/hades.png',
    action: 'VIEW_CENTER_CARD',
    targets: ['center']
  },
  {
    id: 'eris',
    name: 'Eris',
    team: 'werewolf', 
    description: 'Bir oyuncuyu susturur (tartışma sırasında konuşamaz).',
    actionDescription: 'Susturmak istediğin bir oyuncu seç.',
    turnOrder: 4,
    image: '/images/cards/eris.png',
    action: 'SILENCE_PLAYER',
    targets: ['player']
  },
  {
    id: 'sisyphos',
    name: 'Sisyphos',
    team: 'tanner',
    description: 'Eğer öldürülürse kazanır.',
    actionDescription: 'Hiçbir aksiyon yok. Öldürülürsen kazanırsın!',
    turnOrder: 0,
    image: '/images/cards/sisyphos.png',
    action: 'NONE',
    targets: ['none']
  },
  {
    id: 'loki',
    name: 'Loki',
    team: 'villager',
    description: 'Başka bir oyuncunun kartını görür ve o karta dönüşür.',
    actionDescription: 'Kartını görmek ve o karta dönüşmek istediğin bir oyuncu seç.',
    turnOrder: 1,
    image: '/images/cards/loki.png',
    action: 'COPY_PLAYER_CARD',
    targets: ['player']
  },
  {
    id: 'odin',
    name: 'Odin',
    team: 'villager',
    description: 'Başka bir oyuncunun kartını görür.',
    actionDescription: 'Kartını görmek istediğin bir oyuncu seç.',
    turnOrder: 5,
    image: '/images/cards/odin.png',
    action: 'VIEW_PLAYER_CARD',
    targets: ['player']
  },
  {
    id: 'hermes',
    name: 'Hermes',
    team: 'villager',
    description: 'Başka bir oyuncunun kartını çalar.',
    actionDescription: 'Kartını çalmak istediğin bir oyuncu seç.',
    turnOrder: 6,
    image: '/images/cards/hermes.png',
    action: 'STEAL_CARD',
    targets: ['player']
  },
  {
    id: 'aphrodite',
    name: 'Aphrodite',
    team: 'villager',
    description: 'İki oyuncunun kartlarını birbiriyle değiştirir (onlara söylemeden).',
    actionDescription: 'Kartlarını değiştirmek istediğin iki oyuncuyu seç.',
    turnOrder: 7,
    image: '/images/cards/aphrodite.png',
    action: 'SWAP_PLAYER_CARDS',
    targets: ['player']
  },
  {
    id: 'dionysos',
    name: 'Dionysos',
    team: 'villager',
    description: 'Rastgele bir merkez kartı seçer ve ona dönüşür (ne olduğunu bilmeden).',
    actionDescription: 'Rastgele bir merkez kartı seçilecek ve ona dönüşeceksin.',
    turnOrder: 8,
    image: '/images/cards/dionysos.png',
    action: 'RANDOM_CENTER_CARD',
    targets: ['none']
  },
  {
    id: 'thor',
    name: 'Thor',
    team: 'villager',
    description: 'Oy verdiği oyuncu anında ölür.',
    actionDescription: 'Hiçbir gece aksiyonun yok. Oy verdiğin kişi anında ölecek!',
    turnOrder: 0,
    image: '/images/cards/thor.png',
    action: 'VOTE_KILLS_TARGET',
    targets: ['none']
  },
  {
    id: 'artemis',
    name: 'Artemis',
    team: 'villager',
    description: 'Eğer öldürülürse, oy verdiği oyuncu da ölür.',
    actionDescription: 'Hiçbir aksiyon yok. Öldürülürsen, oy verdiğin kişi de ölür!',
    turnOrder: 0,
    image: '/images/cards/artemis.png',
    action: 'NONE',
    targets: ['none']
  },
  {
    id: 'zeus',
    name: 'Zeus',
    team: 'villager',
    description: 'Oyun sonunda bir oyuncunun kartını herkese gösterir.',
    actionDescription: 'Kartını herkese göstermek istediğin bir oyuncu seç.',
    turnOrder: 9,
    image: '/images/cards/zeus.png',
    action: 'REVEAL_AT_END',
    targets: ['player']
  },
  {
    id: 'gareth',
    name: 'Gareth',
    team: 'villager',
    description: 'İki oyuncunun kartını görür; eğer biri kurt ya da düzenbazsa o role dönüşür.',
    actionDescription: 'Kartlarını görmek istediğin iki oyuncuyu seç.',
    turnOrder: 10,
    image: '/images/cards/gareth.png',
    action: 'VIEW_TWO_CARDS_CHANGE_ROLE',
    targets: ['player']
  },
  {
    id: 'brokk',
    name: 'Brokk',
    team: 'villager',
    description: 'Hiçbir özel gücü yoktur, sadece bir köylüdür.',
    actionDescription: 'Hiçbir aksiyonun yok. Köyü korumalısın.',
    turnOrder: 0,
    image: '/images/cards/brokk.png',
    action: 'NONE',
    targets: ['none']
  },
  {
    id: 'sindri',
    name: 'Sindri',
    team: 'villager',
    description: 'Hiçbir özel gücü yoktur, sadece bir köylüdür.',
    actionDescription: 'Hiçbir aksiyonun yok. Köyü korumalısın.',
    turnOrder: 0,
    image: '/images/cards/sindri.png',
    action: 'NONE',
    targets: ['none']
  }
];

export default cards;

// Helper function to get cards by team
export const getCardsByTeam = (team) => {
  return cards.filter(card => card.team === team);
};

// Helper function to get all available card ids
export const getCardIds = () => {
  return cards.map(card => card.id);
};

// Helper function to get a card by id
export const getCardById = (id) => {
  return cards.find(card => card.id === id);
};

// Helper function to get cards in turn order
export const getCardsInTurnOrder = () => {
  return [...cards].filter(card => card.turnOrder > 0).sort((a, b) => a.turnOrder - b.turnOrder);
};
